import { useGAPageViews } from '@dx-ui/dx-common';
import { ShowContext, useShowController } from 'react-admin';
import InvoiceShowView from './InvoiceShowView';

const InvoiceShow = (props) => {
  useGAPageViews();
  const controllerProps = useShowController(props);
  return (
    <ShowContext.Provider value={controllerProps}>
      <InvoiceShowView controllerProps={controllerProps} {...props} />
    </ShowContext.Provider>
  );
};

export default InvoiceShow;
